import { gql } from '@apollo/client';

export const UPDATE_PICKUP_APPOINTMENT = gql`
  mutation UpdatePickupAppointment($input: UpdatePickupAppointmentInput!) {
    updatePickupAppointment(input: $input)
  }
`;

export const UPDATE_COMPLETED_PICKUP_APPOINTMENT = gql`
  mutation UpdateCompletedPickupAppointment($input: UpdatePickupAppointmentInput!) {
    updateCompletedPickupAppointment(input: $input)
  }
`;

export interface UpdatePickupAppointmentInput {
  appointmentId: string;
  taskId: string;
  actualParcelCount: number;
  actualParcelUnit: number;
  photosS3KeysJson: string[];
  actualPickupDate: string;
  actualPickupTimeEnd: string;
  cooperationWarehouseId?: string;
}

export interface UpdatePickupAppointmentVariables {
  input: UpdatePickupAppointmentInput;
}

export interface UpdatePickupAppointmentResponse {
  updatePickupAppointment: boolean;
}

export interface UpdateCompletedPickupAppointmentResponse {
  updateCompletedPickupAppointment: boolean;
} 